import "./App.css";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import React, { useState } from "react";
import Alert from "./components/Alert";

function App() {
  const [mode, setMode] = useState("light"); // Whether dark mode is enabled or not
  const [navBgColor, setNavBgColor] = useState("light");
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };

  const changeTheme = (e) => {
    if (e.target.innerText === "Blue") {
      setMode("primary");
      setNavBgColor("dark");
      document.body.style.backgroundColor = "#B9D9EB";
      showAlert("Blue Theme has been enabled", "success");
    } else if (e.target.innerText === "Green") {
      setMode("success");
      setNavBgColor("dark");
      document.body.style.backgroundColor = "#F0FFF0";
      showAlert("Green Theme has been enabled", "success");
    } else if (e.target.innerText === "Red") {
      setMode("danger");
      setNavBgColor("dark");
      document.body.style.backgroundColor = "#FDBCB4";
      showAlert("Red Theme has been enabled", "success");
    } else if (e.target.innerText === "Yellow") {
      setMode("warning");
      setNavBgColor("dark");
      document.body.style.backgroundColor = "#FFFDD0";
      showAlert("Yellow Theme has been enabled", "success");
    } else if (e.target.innerText === "Light") {
      setMode("light");
      setNavBgColor("light");
      document.body.style.backgroundColor = "white";
      showAlert("Light mode has been enabled", "success");
    } else if (e.target.innerText === "Dark") {
      setMode("dark");
      setNavBgColor("dark");
      document.body.style.backgroundColor = "#042743";
      showAlert("Dark mode has been enabled", "success");
    }
  };
  return (
    <>
      <Navbar
        title="TextEditor"
        navBgColor={navBgColor}
        mode={mode}
        changeTheme={changeTheme}
      />
      <Alert alert={alert} />
      <div className="container my-3">
        <TextForm
          showAlert={showAlert}
          heading="Try TextEditor : Word counter, Character counter, Remove extra spaces"
          mode={mode}
        />
      </div>
    </>
  );
}

export default App;
